import { Badge } from '@/components/ui/badge'
import { ParticipantRole } from '@/types/groupChat'

interface RoleBadgeProps {
    role: ParticipantRole
    className?: string
}

/**
 * RoleBadge Component
 * Displays a colored badge indicating the participant's role in a group chat
 */
export default function RoleBadge({ role, className = '' }: RoleBadgeProps) {
    const getRoleConfig = (role: ParticipantRole) => {
        switch (role) {
            case 'ADMIN':
                return {
                    label: 'Admin',
                    variant: 'default' as const,
                    className: 'bg-blue-600 hover:bg-blue-700 text-white',
                    description: 'Full control over the group',
                }
            case 'MODERATOR':
                return {
                    label: 'Moderator',
                    variant: 'secondary' as const,
                    className: 'bg-purple-600 hover:bg-purple-700 text-white',
                    description: 'Can manage participants and invites',
                }
            case 'MEMBER':
                return {
                    label: 'Member',
                    variant: 'outline' as const,
                    className: 'bg-gray-100 hover:bg-gray-200 text-gray-700',
                    description: 'Can view and send messages',
                }
        }
    }

    const config = getRoleConfig(role)

    return (
        <Badge
            variant={config.variant}
            className={`text-xs ${config.className} ${className}`}
            title={config.description}
        >
            {config.label}
        </Badge>
    )
}
